import { assignFee } from '@/modules/api/post/assignFee'
import { removeOtherFee } from '@/modules/api/post/removeOtherFee'
import { removeActivityFee } from '@/modules/api/post/removeActivityFee'
import { transitCardData } from '@/modules/api/post/transitCardData'
import { vericheckData } from '@/modules/api/post/vericheckData'
import { achSession, addTsysAch } from '@/modules/api/post/tsysAchData'
import { orderEstimate } from '@/modules/api/post/orderEstimate'
import { orderEstimateWithoutFS } from '@/modules/api/post/orderEstimateWithoutFS'
import { checkout } from '@/modules/api/post/checkout'
import { login } from '@/modules/api/post/login'
import { loginWithToken } from '@/modules/api/post/loginWithToken'
import { logout } from '@/modules/api/post/logout'
import { setLocaleCode } from '@/modules/api/post/setLocaleCode'
import { addFormToken } from '@/modules/api/post/addFormToken.ts'
import { setFormSubmissionId } from '@/modules/api/post/setFormSubmissionId.ts'
import { getFormDetailsUrl } from '@/modules/api/post/formDetailsUrl.ts'
import { getFormPdfUrl } from '@/modules/api/post/formPdfUrl.ts'
import { setTuitionFormSubmissionId } from '@/modules/api/post/setTuitionFormSubmissionId.ts'
import { submitContractRevision } from '@/modules/api/post/submitContractRevision.ts'
import { autoPayTermsStatus } from '@/modules/api/post/autoPayTermsStatus.ts'
import { applyDeposit } from '@/modules/api/post/applyDeposit.ts'
import { saveNotificationSettings } from '@/modules/api/post/saveNotificationSettings.ts'
import { saveAutoRefill } from '@/modules/api/post/saveAutoRefill.ts'
import { saveStudentMealSettings } from '@/modules/api/post/saveStudentMealSettings.ts'
import { saveContactPreferences } from '@/modules/api/post/saveContactPreferences.ts'
import { updateBillingAddress } from '@/modules/api/post/updateBillingAddress.ts'
import { updateEmail } from '@/modules/api/post/updateEmail.ts'
import { updatePhone } from '@/modules/api/post/updatePhone.ts'
import { updateSecurityQuestion } from '@/modules/api/post/updateSecurityQuestion.ts'
import { updatePassword } from '@/modules/api/post/updatePassword.ts'
import { freeReducedUrl } from '@/modules/api/post/freeReducedUrl.ts'
import { generateSsoUrl } from '@/modules/api/post/generateSsoUrl.ts'
import { ssoLogin } from '@/modules/api/post/ssoLogin.ts'
import { createStudent } from '@/modules/api/post/createStudent.ts'
import { postEnrollment } from '@/modules/api/post/postEnrollment.ts'
import { saveAutoPaymentSettings } from '@/modules/api/post/saveAutoPaymentSettings.ts'
import { contractRevisionAutoPay } from '@/modules/api/post/contractRevisionAutoPay.ts'
import { setContractRevisionAutoPay } from '@/modules/api/post/setContractRevisionAutoPay.ts'
import { saveAutoPayContractSettings } from '@/modules/api/post/saveAutoPayContractSettings.ts'
import { manageTransactionChildcareSlots } from '@/modules/api/post/manageTransactionChildcareSlots.ts'
import { resendActivationLink } from '@/modules/api/post/resendActivationLink.ts'
import { saveLowBalanceNoticeLevel } from '@/modules/api/post/saveLowBalanceNoticeLevel.ts'
import { quickpayApple } from '@/modules/api/post/QuickpayApple.ts'
import { quickpayAppleValidateMerchant } from '@/modules/api/post/QuickpayAppleValidateMerchant.ts'
import { quickpayGoogle } from '@/modules/api/post/QuickpayGoogle.ts'
import { exchangeToken } from '@/modules/api/post/exchangeToken.ts'
import { clearAutoPaymentSettings } from '@/modules/api/post/clearAutoPaymentSettings.ts'
import { invoiceDueDatePreview } from '@/modules/api/post/invoiceDueDatePreview.ts'
import { enrollmentDashboardToken } from '@/modules/api/post/enrollmentDashboardToken.ts'
import { enrollmentPortalDeviceProof } from '@/modules/api/post/enrollmentPortalDeviceProof.ts'
import { enrollmentAddTransitCard } from '@/modules/api/post/enrollmentAddTransitCard.ts'
import { enrollmentAddBankAccount } from '@/modules/api/post/enrollmentAddBankAccount.ts'
import { enrollmentFundingSourcePay } from '@/modules/api/post/enrollmentFundingSourcePay.ts'
import { enrollmentCancelCart } from '@/modules/api/post/enrollmentCancelCart.ts'
import { enrollmentRequestCode } from '@/modules/api/post/enrollmentRequestCode.ts'
import { enrollmentEmailQuickpayLink } from '@/modules/api/post/enrollmentEmailQuickpayLink.ts'
import { enrollmentVerifyCode } from '@/modules/api/post/enrollmentVerifyCode.ts'
import { enrollmentCreateAccount } from '@/modules/api/post/enrollmentCreateAccount.ts'
import { enrollmentAccept } from '@/modules/api/post/enrollmentAccept.ts'
import { enrollmentAcceptTerms } from '@/modules/api/post/enrollmentAcceptTerms.ts'
import { enrollmentRequestReactivation } from '@/modules/api/post/enrollmentRequestReactivation.ts'
import {
  athleticsConversationMessage,
  athleticsStudentMessage
} from '@/modules/api/post/athleticsMessage'
import {
  generateMcpCredentials,
  regenerateMcpCredentials
} from '@/modules/api/post/mcpCredentials.ts'
import { disconnectMcpConnection } from '@/modules/api/post/mcpConnections.ts'

export const Post = {
  generateMcpCredentials,
  regenerateMcpCredentials,
  disconnectMcpConnection,
  assignFee,
  removeOtherFee,
  removeActivityFee,
  transitCardData,
  vericheckData,
  achSession,
  addTsysAch,
  orderEstimate,
  orderEstimateWithoutFS,
  checkout,
  login,
  loginWithToken,
  logout,
  setLocaleCode,
  addFormToken,
  setFormSubmissionId,
  getFormDetailsUrl,
  getFormPdfUrl,
  setTuitionFormSubmissionId,
  submitContractRevision,
  autoPayTermsStatus,
  applyDeposit,
  saveNotificationSettings,
  saveAutoRefill,
  saveStudentMealSettings,
  saveContactPreferences,
  updateBillingAddress,
  updateEmail,
  updatePhone,
  updateSecurityQuestion,
  updatePassword,
  freeReducedUrl,
  generateSsoUrl,
  ssoLogin,
  createStudent,
  postEnrollment,
  saveAutoPaymentSettings,
  contractRevisionAutoPay,
  setContractRevisionAutoPay,
  saveAutoPayContractSettings,
  manageTransactionChildcareSlots,
  resendActivationLink,
  saveLowBalanceNoticeLevel,
  quickpayApple,
  quickpayAppleValidateMerchant,
  quickpayGoogle,
  exchangeToken,
  clearAutoPaymentSettings,
  invoiceDueDatePreview,
  enrollmentDashboardToken,
  enrollmentPortalDeviceProof,
  enrollmentAddTransitCard,
  enrollmentAddBankAccount,
  enrollmentFundingSourcePay,
  enrollmentCancelCart,
  enrollmentRequestCode,
  enrollmentEmailQuickpayLink,
  enrollmentVerifyCode,
  enrollmentCreateAccount,
  enrollmentAccept,
  enrollmentAcceptTerms,
  enrollmentRequestReactivation,
  athleticsStudentMessage,
  athleticsConversationMessage
}
